export var FONT_FAMILIES = [
    'Helvetica',
    'Lobster,cursive',
    'Pacifico,cursive',
    'Josefin Sans,sans-serif'
];
export var COLORS = [
    '#FFFFFF',
    '#000000',
    '#31D0C6',
    '#7C68FC',
    '#FE854F',
    '#FEB663',
    '#222138',
    '#33334E',
    '#4B4A67',
    '#3c4260',
    '#6A6C8A',
    '#C6C7E2',
    '#f6f6f6'
];
export var FONT_SIZES = [
    '10px',
    '12px',
    '14px',
    '16px',
    '18px',
    '24px',
    '36px',
    '48px',
    '72px'
];
export var DEFAULT_TEXT_ATTRIBUTES = {
    'fill': COLORS[7],
    'font-size': parseInt(FONT_SIZES[1]),
    'font-family': FONT_FAMILIES[0],
    'font-weight': 'normal',
    'text-decoration': 'none',
    'font-style': 'normal',
};
